import { createStore } from 'stimulus-store';

export const areaStore = createStore({
    name: 'areaStore',
    type: Object,
    initialValue: {}
});